<span class="custom-control custom-radio mr-3">
  <input
    type="radio"
    class="custom-control-input"
    [checked]="checked"
    [disabled]="disabled"
    [attr.id]="id"
    [attr.name]="name"
    [value]="value"
    (change)="onInputChange($event)"
    (click)="onInputClick($event)"
  />
  <label class="custom-control-label note" [attr.for]="id">
    <ng-content></ng-content>
  </label>
</span>
